var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconStatusEnqueued24 = function SvgAIconStatusEnqueued24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 10,
    fill: "#FFB500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V12.1893L16.0303 15.4697C16.3232 15.7626 16.3232 16.2374 16.0303 16.5303C15.7374 16.8232 15.2626 16.8232 14.9697 16.5303L11.4697 13.0303C11.329 12.8897 11.25 12.6989 11.25 12.5V8C11.25 7.58579 11.5858 7.25 12 7.25Z",
    fill: "white"
  })));
};
export { SvgAIconStatusEnqueued24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMi41IiByPSIxMCIgZmlsbD0iI0ZGQjUwMCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDcuMjVDMTIuNDE0MiA3LjI1IDEyLjc1IDcuNTg1NzkgMTIuNzUgOFYxMi4xODkzTDE2LjAzMDMgMTUuNDY5N0MxNi4zMjMyIDE1Ljc2MjYgMTYuMzIzMiAxNi4yMzc0IDE2LjAzMDMgMTYuNTMwM0MxNS43Mzc0IDE2LjgyMzIgMTUuMjYyNiAxNi44MjMyIDE0Ljk2OTcgMTYuNTMwM0wxMS40Njk3IDEzLjAzMDNDMTEuMzI5IDEyLjg4OTcgMTEuMjUgMTIuNjk4OSAxMS4yNSAxMi41VjhDMTEuMjUgNy41ODU3OSAxMS41ODU4IDcuMjUgMTIgNy4yNVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";